class Stream {
    constructor(url, port) {
        this.reqArray = [];
        this.pendingToBeConsumed = "";
        this.WS = new WebSocket(url + ":" + port + "/websocket");
    }
    WSRequest(req) {
        var _a;
        let resetPush = true;
        const newPayload = JSON.parse(req.payload);
        if (((_a = this.reqArray) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            this.reqArray.map((z, i) => {
                const oldpayload = JSON.parse(z.payload);
                if (newPayload.request.request_type === "subscribe") {
                    if (oldpayload.request.streaming_type ===
                        newPayload.request.streaming_type) {
                        this.reqArray[i] = req;
                        resetPush = false;
                    }
                }
            });
            if (newPayload.request.request_type === "subscribe" && resetPush) {
                this.reqArray.push(req);
            }
        }
        else {
            if (newPayload.request.request_type === "subscribe") {
                this.reqArray.push(req);
            }
        }
        return new Promise((resolve, reject) => {
            let msgReadyToSend = false;
            const waitingForConn = setInterval(() => {
                if (!msgReadyToSend && this.WS.readyState === 1) {
                    this.WS.send(req.payload + "\n");
                    msgReadyToSend = true;
                }
                else {
                    clearInterval(waitingForConn);
                }
            }, 100);
            //heart beat pinged every two minutes to keep the socket connection alive, not related to request
            // setInterval(() => {
            //   if (this.WS.readyState === 1) this.WS.send(JSON.stringify({}) + "\n");
            // }, 120000);
            this.WS.onopen = (_e) => {
                try {
                    // WS.readyState
                    if (this.WS.readyState === 1 && !msgReadyToSend) {
                        this.WS.send(req.payload + "\n");
                        msgReadyToSend = true;
                    }
                    resolve(this.WS);
                }
                catch (e) {
                    reject(e);
                }
            };
            this.WS.onmessage = (e) => {
                this.handleBrokenPackets(e.data);
            };
            this.WS.onclose = (e) => {
                console.log("Connection closed ");
                console.log("Initiated Connection");
                this.reqArray.map((req) => {
                    this.WSRequest(req);
                });
            };
            this.WS.onerror = (e) => {
                console.log("Connection errored ", e);
                console.log("Initiated Connection");
                this.reqArray.map((req) => {
                    this.WSRequest(req);
                });
            };
        });
    }
    //to close webscoket connection from client end
    closeSocketConn() {
        this.WS.close();
    }
    handleBrokenPackets(resData) {
        const arrayToBeConsumed = [];
        let readData = resData;
        if (this.pendingToBeConsumed.length > 0) {
            readData = this.pendingToBeConsumed + readData;
            this.pendingToBeConsumed = "";
        }
        let arr1 = readData.split("\n");
        arrayToBeConsumed.push(...arr1.slice(0, arr1.length - 1));
        if (!readData.endsWith("\n")) {
            this.pendingToBeConsumed = arr1[arr1.length - 1];
        }
        this.reqArray.map((z, i) => {
            const oldpayload = JSON.parse(z.payload);
            arrayToBeConsumed.map((x) => {
                var _a, _b;
                const respData = JSON.parse(x);
                if (((_a = oldpayload === null || oldpayload === void 0 ? void 0 : oldpayload.request) === null || _a === void 0 ? void 0 : _a.streaming_type) ===
                    ((_b = respData === null || respData === void 0 ? void 0 : respData.response) === null || _b === void 0 ? void 0 : _b.streaming_type)) {
                    z.message(x);
                }
            });
        });
    }
}
export default Stream;
